import { getAppStore } from '~src/app/AppStore';
import { selectContentFromAppState } from '~src/app/selectors/ContentSelectors';
import { WebClientListResourceFetcher } from '~src/commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/ts/resources/ResourceQuery';

import { GetResourceGovernanceSiteSettingsRequest, IGetResourceGovernanceSiteSettingsResult, IResourceGovernanceSiteSetting } from './ResourceGovernance';

export type ResourceGovernanceAllowedActions = Readonly<{}>;

export namespace ResourceGovernanceService {
  export function resultMapper(result: IGetResourceGovernanceSiteSettingsResult): IResourceGovernanceSiteSetting[] {
    return result.settings.map(s => ({
      ...s,
      contentType: 'resourceGovernanceSetting',
    }));
  }

  export function all(): ResourceQuery<IResourceGovernanceSiteSetting> {
    const fetcher = new WebClientListResourceFetcher(GetResourceGovernanceSiteSettingsRequest, resultMapper);
    return new ResourceQuery(fetcher);
  }

  export function actions(): Promise<ResourceGovernanceAllowedActions> {
    const items = selectContentFromAppState(getAppStore().getState()) as unknown as IResourceGovernanceSiteSetting[];
    return Promise.resolve({});
  }
}
